/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardTemplatesAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the dashboard templates.
 */
define([], () => {
	class DashboardTemplatesAPI{

		/**
		 * @function DashboardTemplatesAPI#destroy
		 * @description destroy this instance
		 */
		destroy(){}

		/**
		 * @function DashboardTemplatesAPI#listTemplates
		 * @description Get a list of templates sorted by modificationDate
		 * @returns {Promise} Resolves to the list of dashboard templates found
		 */
		listTemplates(){}

		/**
		 * @function DashboardTemplatesAPI#getTemplate
		 * @description Get the content of a specific template
		 * @param {string} id The id of the dashboard template who's content is to be returned
		 * @param {boolean} includeSpec Whether or not the specficiation of the dashboard template should be included in the output
		 * @returns {Promise} Resolves to the requested dashboard template content
		 */
		getTemplate(){}

		/**
		 * @function DashboardTemplatesAPI#getThumbnail
		 * @description Get the thumbnail associated with a specific dashboard template
		 * @param {string} id The id of the dashboard template who's thumbnail is to be returned
		 * @returns {Promise} Resolves to the requested dashboard template thumbnail
		 */
		getThumbnail(){}
	}

	return DashboardTemplatesAPI;
});